/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hidepassword1Inputs */

const en_hidepassword1 = /** @type {(inputs: Hidepassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide password`)
};

const de_hidepassword1 = /** @type {(inputs: Hidepassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort verbergen`)
};

/**
* | output |
* | --- |
* | "Hide password" |
*
* @param {Hidepassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const hidepassword1 = /** @type {((inputs?: Hidepassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hidepassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hidepassword1(inputs)
	return de_hidepassword1(inputs)
});
export { hidepassword1 as "hidePassword" }